// Import model
import { CreateWasteFactorRequest } from '../models/CreateWasteFactorRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateWasteFactorRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateWasteFactorRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateWasteFactorRequest instance
   */
  static deserialize(json: string): CreateWasteFactorRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateWasteFactorRequest instance
   */
  static fromObject(obj: any): CreateWasteFactorRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateWasteFactorRequest');
    }


    const instance: CreateWasteFactorRequest = {
      productType: obj['productType'] as string,
      patternTypeId: obj['patternTypeId'] as string | undefined,
      catalogFeedId: obj['catalogFeedId'] as string | undefined,
      itemId: obj['itemId'] as string | undefined,
      styleNumber: obj['styleNumber'] as string | undefined,
      name: obj['name'] as string,
      description: obj['description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateWasteFactorRequest instances
   */
  static deserializeArray(json: string): CreateWasteFactorRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateWasteFactorRequest instance to a JSON string
   */
  static serialize(instance: CreateWasteFactorRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateWasteFactorRequest instance to a plain object
   */
  static toObject(instance: CreateWasteFactorRequest): any {
    return {
      'productType': instance.productType,
      'patternTypeId': instance.patternTypeId,
      'catalogFeedId': instance.catalogFeedId,
      'itemId': instance.itemId,
      'styleNumber': instance.styleNumber,
      'name': instance.name,
      'description': instance.description,
    };
  }

  /**
   * Serializes an array of CreateWasteFactorRequest instances to a JSON string
   */
  static serializeArray(instances: CreateWasteFactorRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
